<div id="top">

  <div class="titlebar-div" id="titlebar-div">
    <span><a class="cvt-icon-back grid-cmd-icons leftIcon" title="Previous Month" (click)="loadPrevious()" ></a></span>
    <span class="rightIcon"><a class="cvt-icon-forward grid-cmd-icons rightIcon" title="Next Month" (click)="loadNext()" ></a></span>
    <span class="divText"><span>{{numberOfDatesSelected}} Date(s) Selected</span><br><span>{{numberOfDatesRemaining}} Date(s) Available</span></span>
    <!-- <span class="divTextDate">{{monthName}}&nbsp;-&nbsp;{{year}}</span> -->
    <span class="divTextDate">Processing Date Selection</span>

  </div>

  <!-- <div class="allCalendars" id="calendar1"></div>
<div class="allCalendars" id="calendar2"></div>
<div class="allCalendars" id="calendar3"></div> -->
  <div class="threeMonths">
    <div class="calendarMonth" *ngFor="let m of monthsIndex">
      <div class="monthNameRow">
        <div class="monthName">
          <span [innerText]="monthNames[m]"></span>
        </div>
      </div>
      <div class="daysRow">
        <div class="daysCell" *ngFor="let dayname of dayNames">
          <span [innerText]="dayname"></span>
        </div>
      </div>
      <div class="dateField">
        <div class="rowStyle" *ngFor="let wk of weeksIndex; let w=index">
          <div class="cellStyle" *ngFor="let day of daysIndex; let d=index; trackBy: trackById;" (click)=toggleSelect(m,w,d)  >
            <span [class]="getClassString(m,w,d)" [innerText]="getDayString(m,w,d)"  [attr.dayIndex]='m*35+w*7+d' ></span>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
